import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {CIVILITIES} from '../../constants';

/**
 *
 * @param t
 * @param children
 * @returns {string}
 */
function TranslatedCivility({t, children}) {
  return children ? t(`civilities.${children}`) : '';
}

TranslatedCivility.propTypes = {
  t: PropTypes.func.isRequired,
  children: PropTypes.oneOf(Object.values(CIVILITIES)),
};

export default withTranslation('user')(TranslatedCivility);
